import { Machine } from 'xstate';

export default Machine({
  id: 'ad-preview',
  initial: 'idle',
  states: {
    idle: {
      on: {
        GENERATE_PREVIEW: 'loading',
      },
    },
    loading: {
      invoke: {
        src: 'getIframe',
        onDone: {
          target: 'idle',
          actions: ['setIframe'],
        },
        onError: {
          target: 'idle',
          actions: ['alertOfIframeError'],
        },
      },
      after: {
        10000: {
          target: 'idle',
          actions: ['alertOfLoadingError'],
        },
      },
    },
  },
});
